import React, { useContext, useEffect, useMemo, useState } from 'react';
import HeaderRoutes from '../../components/HeaderRoutes/HeaderRoutes';
import { Box, Card, Grid, MenuItem, Paper, TextField, ToggleButtonGroup, ToggleButton, Switch, FormControlLabel } from '@mui/material';
import AuthContext, { reloadUserData } from '../../context/AuthContext';
import ButtonTheme from '../../components/ThemeButton/ThemeButton';
import { useForm } from 'react-hook-form';
import { useSnackbar } from 'notistack';
import ApiService from '../../functions/apiService';
import ProfileSocialMedia from '../../components/Profile/ProfileSocialMedia';
import Error from '../../components/Error/Error';
import { useSelector } from 'react-redux';
import { setMyBalance } from '../../store/myShiftsReducer';
import { useDispatch } from 'react-redux';
import MyBalanceTable from '../../components/MyShifts/MyBalanceTable';
import UserCertificates from './userCertificates';
import UserSwapReport from './userSwapReport';
import MyTable from "../../components/Schedule/MyTable";
import { styled } from '@mui/material/styles';
import SellHoliday from './SellHoliday';
import SellHolidayTable from './SellHolidayTable';
import { toast } from 'react-toastify';
import axios from 'axios';

// import ChangePassword from './changePassword';
import UserSettingsHeader from '../../components/HeadersNav/userSettingsHeader';

const PreferencesForm = ({ Preferences }) => {
  const { user, pages } = useContext(AuthContext);

  // const { enqueueSnackbar } = useSnackbar();
  const {
    register,
    formState: { errors },
    handleSubmit,
    setError,
    setValue,
    getValues,
    watch,
  } = useForm();
  const [saving, setSaving] = useState(false);
  const [showDropdoun, setShowDropdoun] = useState(false);
  const [anyChange, setAnyChange] = useState(true);

  useEffect(() => {
    const subscription = watch((value, { name, type }) => {
      if (type == 'change' || type == 'click') {
        setAnyChange(false);
      }
    });
    return () => { };
  }, [watch]);


  const onSubmit2 = d => {
    setSaving(true);
    let DONOTDISTURB = d.DONOTDISTURB ?? false;
    let body = {
      DONOTDISTURB: DONOTDISTURB,
      Preference: d,
    };

    delete d.DONOTDISTURB;

    ApiService.post('/updateProfilePreferences', body)
      .then(data => {
        setSaving(false);
        toast.success("Success")
        // enqueueSnackbar('Success', { variant: 'success' });
      })
      .catch(({ data }) => {
        setSaving(false);
        setError('PrimaryPhone', {
          type: 'manual',
          message: data.message,
        });
      });
  };

  useEffect(() => {
    if (Preferences) {
      setValue(
        'DONOTDISTURB',
        Preferences &&
        Preferences.userData &&
        Preferences.userData.find(i => i.User_Option == 'DO_NOT_DISTURB') &&
        true
      );
      setShowDropdoun(
        Preferences &&
        Preferences.userData &&
        Preferences.userData.find(i => i.User_Option == 'DO_NOT_DISTURB') &&
        true
      );
      // Preferences.select.forEach(element => {
      //     setValue(element.Overtime_List,  Preferences.userData.find(i=>i.User_Option == element.Overtime_List).User_Value);
      // });
    }
  }, [Preferences]);

  let SwitchChanges = () => {
    setShowDropdoun(getValues().DONOTDISTURB);
  };

  return (
    <Card className='shadow p-3 mt-3'>
      <form onSubmit={handleSubmit(onSubmit2)}>
        <h6 className='fs-5 fw-600 my-2'>Contact Preferences</h6>
        {!pages.includes('V3_MEMBER_DONOT_CALL') && (
          <Box className='my-2'>
            <div
              className='form-check form-switch d-flex align-items-center'
              style={{ height: '50px' }}
            >
              <input
                onInput={SwitchChanges}
                style={{ width: '40px', height: '25px' }}
                {...register('DONOTDISTURB')}
                id='flexSwitch'
                className='form-check-input'
                type='checkbox'
                role='switch'
              />
              <label className='form-check-label mx-2' htmlFor='flexSwitch'>
                Do Not Disturb
              </label>
            </div>
          </Box>
        )}
        <Grid
          className='my-1 placeholder-glow'
          container
          spacing={2}
          columns={{ xs: 4, sm: 4, md: 4 }}
        >
          {Preferences &&
            Preferences.select &&
            Preferences.select.map(item => {
              return (
                <Grid className='pt-2' item xs={2} sm={1} md={1} key={item.Overtime_List + 'item'}>
                  <TextField
                    disabled={showDropdoun}
                    className='mt-0 w-100 text-dark text-uppercase'
                    color='secondary'
                    variant='outlined'
                    InputLabelProps={{
                      style: {
                        textTransform: 'capitalize',
                      },
                    }}
                    select
                    size='small'
                    sx={{
                      '& .MuiSelect-select': {
                        textTransform: 'capitalize',
                        height: '30px !important',
                      },
                    }}
                    label={`${item?.Overtime_List_Description?.toLowerCase()}`}
                    {...register(item.Overtime_List, {
                      required: 'Field is required',
                    })}
                    // defaultValue={
                    //   Preferences.userData.find(
                    //     (i) =>
                    //       i.User_Option ==
                    //       item.Overtime_List
                    //   )?.User_Value
                    // }
                    defaultValue={
                      Preferences.userData.find(i => i.User_Option === item.Overtime_List)
                        ?.User_Value || Preferences.options?.[0]?.SO_Value
                    }
                  >
                    {Preferences &&
                      Preferences.options &&
                      Preferences.options.map(i => {
                        return (
                          <MenuItem
                            key={i.SO_Value + 'p' + item.Overtime_List}
                            value={i.SO_Value}
                            className='text-capitalize'
                          >
                            {i.SO_Desc.toLowerCase()}
                          </MenuItem>
                        );
                      })}
                  </TextField>
                  {errors[item.Overtime_List] && (
                    <p style={{ color: 'red' }}>{errors[item.Overtime_List]?.message}</p>
                  )}
                </Grid>
              );
            })}

          {!Preferences && (
            <>
              <Grid className='pt-2' item xs={2} sm={1} md={1}>
                <span className='placeholder col-12' style={{ height: '60px' }}></span>
              </Grid>
              <Grid className='pt-2' item xs={2} sm={1} md={1}>
                <span className='placeholder col-12' style={{ height: '60px' }}></span>
              </Grid>
              <Grid className='pt-2' item xs={2} sm={1} md={1}>
                <span className='placeholder col-12' style={{ height: '60px' }}></span>
              </Grid>
              <Grid className='pt-2' item xs={2} sm={1} md={1}>
                <span className='placeholder col-12' style={{ height: '60px' }}></span>
              </Grid>
            </>
          )}

          <Grid className='pt-2' item xs={4} sm={4} md={4}>
            <div className='d-flex justify-content-end'>
              <ButtonTheme
                disabled={saving || anyChange}
                type='submit'
                variant='filled'
                color='primary'
                className='px-5 my-2'
              >
                {saving && 'Loading...'}
                {!saving && 'Save'}
              </ButtonTheme>
            </div>
          </Grid>
        </Grid>
      </form>
    </Card>
  );
};

export default function UserSetting() {
  const { user, pagesName, pages , department , v3Data} = useContext(AuthContext);
  const allowedVars = v3Data;
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const MyBalance = useSelector(state => state.myShiftsReducer.MyBalance);
  const [summarySearch, setSummarySearch] = useState("");
  const [data, setData] = useState();
  const [timeFormat, setTimeFormat] = useState(user?.Time_Format);
  const [checked, setChecked] = useState(false);

	useEffect(() => {
		setChecked(allowedVars?.V3_DISPLAY_BADGE || false)
	}, [allowedVars])


  const {
    register, formState: { errors }, handleSubmit, setError, watch, trigger
  } = useForm({
    defaultValues: {
      PrimaryPhone: user.Primary_phone,
      PhoneType: user.Pphone_type,
      PhoneProvider: user.Pphone_provider,
    },
    reValidateMode: 'onSubmit',
  });

  const StyledToggleButton = styled(ToggleButton)(({ theme }) => ({
    width: 40,
    height: 40,
    textTransform: 'none',
    border: '1px solid #ccc',
    backgroundColor: '#ffffff',
    borderRadius: '60px',
    '&.Mui-selected': {
      backgroundColor: theme.palette.mode === 'dark' ? '1px solid rgba(224, 224, 224, 1)' : '1px solid rgba(224, 224, 224, 1)',
      color: '#555555',
      '&:hover': {
        backgroundColor: theme.palette.mode === 'dark' ? '1px solid rgba(224, 224, 224, 1)' : '1px solid rgba(224, 224, 224, 1)',
      },
    },
  }));

  let groupName = Object.keys(pagesName).includes('GROUP_HEADER_TEXT') ? pagesName.GROUP_HEADER_TEXT : 'Group';
  const [saving, setSaving] = useState(false);
  const [editContactInformation, setEditContactInformation] = useState(false);
  const [Preferences, setPreferences] = useState();
  const [anyChange, setAnyChange] = useState(true);
  const [sellListData, setSellListData] = useState([])

  useEffect(() => {
    const subscription = watch((value, { name, type }) => {
      if (type == 'change' || type == 'click') {
        setAnyChange(false);
      }
    });
    return () => { };
  }, [watch]);

  let loadEmails = () => {
    ApiService.get('/OverTimeListData').then(({ data }) => {
      setPreferences(data);
    });
  };

  let loadData = () => {
    if (MyBalance === undefined || MyBalance.length == 0) {
      ApiService.get('/myShifts', {}, 'myShifts')
        .then(({ data }) => {
          dispatch(setMyBalance(Object.values(data.MyBalance)));
          setLoading(false);
        })
        .catch(() => {
          setLoading(false);
          toast.error("Error")
          // enqueueSnackbar('Error', { variant: 'error' });
        });
    }
  };

  useEffect(() => {
    loadEmails();
    loadData();
    if (document.querySelector("[href='/firehouse/user-settings']")) {
      document
        .querySelector("[href='/firehouse/user-settings']")
        .classList.add('RaMenuItemLink-active');
    }
    return () => {
      if (document.querySelector("[href='/firehouse/user-settings']")) {
        document
          .querySelector("[href='/firehouse/user-settings']")
          .classList.remove('RaMenuItemLink-active');
      }
    };
  }, []);

  const onSubmit = d => {
    setSaving(true);
    ApiService.post('/updateProfile', d)
      .then(data => {
        // variant could be success, error, warning, info, or default
        setSaving(false);
        reloadUserData();
        toast.success("Success")
        // enqueueSnackbar('success', { variant: 'success' });
      })
      .catch(({ data }) => {
        setSaving(false);
        if (data.errors) {
          Object.entries(data.errors).map((e, key) => {
            setError(e[0], { type: 'manual', message: e[1][0] });
          });
        }
      });
  };

  const columnsSummary = [
    { field: "name", headerName: "Type", flex: 1, minWidth: 140 },
    { field: "date", headerName: "Start Date", flex: 1, minWidth: 100 },
    { field: "start", headerName: "Start", flex: 1, minWidth: 50 },
    { field: "carried", headerName: "Carried", flex: 1, minWidth: 70 },
    { field: "accrued", headerName: "Accrued	", flex: 1, minWidth: 70 },
    { field: "sold", headerName: "Sold", flex: 1, minWidth: 50 },
    { field: "used", headerName: "Used", flex: 1, minWidth: 50 },
    { field: "planned", headerName: "Planned", flex: 1, minWidth: 70 },
    { field: "available", headerName: "Available", flex: 1, minWidth: 80 },
  ]

  const columnsSummaryCompressed = [
    { field: "name", headerName: "Type", flex: 1, minWidth: 140 },
    { field: "date", headerName: "Start Date", flex: 1, minWidth: 100 },
    { field: "start", headerName: "Start", flex: 1, minWidth: 50 },
    { field: "carried", headerName: "Carried", flex: 1, minWidth: 70 },
    { field: "accrued", headerName: "Accrued	", flex: 1, minWidth: 70 },
    //{ field: "sold", headerName: "Sold", flex: 1, minWidth: 50 },
    { field: "used", headerName: "Used", flex: 1, minWidth: 50 },
    { field: "planned", headerName: "Planned", flex: 1, minWidth: 70 },
    { field: "available", headerName: "Available", flex: 1, minWidth: 80 },
  ]

  useEffect(() => {
    ApiService.get("/getEmployeeLog/" + user.Emp_Code, {}, "getEmployeeLog")
      .then(({ data }) => {
        setData(data);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
      });
  }, []);

  const summaryRes = useMemo(() => {
    return data?.summary?.filter((x) => {
      return (
        x.name.toLowerCase().includes(summarySearch.toLowerCase()) ||
        x.start.toString().includes(summarySearch.toLowerCase())
      );
    });
  }, [summarySearch, data]);

  let userSellHolidayList = () => {
    ApiService.get('/userAllAccrualRequests').then(({ data }) => {
      setSellListData(data?.data)
    }).catch((error) => {
      toast.error(error)
    })
  };

  useEffect(() => {
    userSellHolidayList()
  }, [])

  const handleFormatChange = (e, newVal) => {
    if (newVal) {
      setTimeFormat(newVal)
      ApiService.post('/changeTimeFormat', {
        Time_Format: newVal
      })
        .then(data => {
          reloadUserData();
          toast.success(data?.message)
          setTimeout(() => window.location.reload(), 1500)
        })
        .catch(({ data }) => {
          console.log(data)
        });
    }
  }

  const handleToggle = (event) => {
		const newValue = event.target.checked;
		setChecked(newValue);
		ApiService.post('/editSystemConfig', {
			id : 'V3_DISPLAY_BADGE',
			Effective_Date : '2024-03-24',  
			Options : 'LOW',
			Type : 'GLOBAL',
			Value: newValue ? "true" : "false",
			Var : 'V3_DISPLAY_BADGE'
		})
			.then(data => {
				toast.success(data?.message || 'success')
			})
			.catch(({ err }) => {
				console.error(err || 'error')
				setChecked(!newValue);
			});
	}

  return (
    <>
      <UserSettingsHeader />
      <h5 className=' mt-4 fw-500'>{user && user.fullName}</h5>
      <p>
        {user &&
          user.employee_assignment &&
          groupName + ' : ' + user.employee_assignment.Group_Code}
        {user && user.AssignmentText != '' && ' , Station: ' + user.AssignmentText}
        {user && user.PossisionText != '' && ' , Position: ' + user.PossisionText}
        {user && user.RankText != '' && ' , Rank: ' + user.RankText}
      </p>
      <Box>
        <Card className='shadow p-3'>
          <div className='d-flex align-items-center mb-4'>
            <h6 className='fs-5 fw-600'>
              Contact Information{' '}
            </h6>
            <ButtonTheme
              color='primary'
              className='rounded-5 mx-2'
              onClick={() => setEditContactInformation(i => !i)}
            >
              {!editContactInformation ? 'Edit' : 'View'}
            </ButtonTheme>
            <div style={{ marginLeft: 'auto', display: 'flex', alignItems: 'center', gap: 16 }}>
              <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2 }}>
                <label>Show Badge</label>
									<Switch
										checked={checked}
										onChange={handleToggle}
										color="primary"
									/>
              </div>
              <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2 }}>
                <label>Time format</label>
                <ToggleButtonGroup
                  value={timeFormat}
                  exclusive
                  aria-label="toggle mode"
                  onChange={handleFormatChange}
                >
                  <StyledToggleButton value="12">
                    12h
                  </StyledToggleButton>
                  <StyledToggleButton value="24">
                    24h
                  </StyledToggleButton>
                </ToggleButtonGroup>
              </div>
            </div>
          </div>
          {editContactInformation && (
            <form onSubmit={handleSubmit(onSubmit)}>
              <Grid container spacing={2} columns={{ xs: 6, sm: 6, md: 6 }}>
                <Grid className='pt-2' item xs={6} sm={4} md={2} sx={{ minHeight: '90px' }}>
                  <TextField
                    {...register('PrimaryPhone', {
                      required: 'Primary Phone is required',
                      pattern: {
                        value: /^\d{0,10}$/,
                        message: 'Please enter a valid phone number',
                      },
                    })}
                    className='mt-0 w-100'
                    color='secondary'
                    variant='outlined'
                    label='Phone (Primary)'
                  // onChange={() => {
                  //     trigger("PrimaryPhone");
                  // }}
                  />

                  {errors.PrimaryPhone?.type === 'required' && (
                    <Error>{errors.PrimaryPhone?.message}</Error>
                  )}
                  {errors.PrimaryPhone?.type === 'pattern' && (
                    <Error>Invalid phone number format must be 10 numbers</Error>
                  )}
                </Grid>
                <Grid className='pt-2' item xs={6} sm={2} md={1} sx={{ minHeight: '90px' }}>
                  <TextField
                    {...register('PhoneType', {
                      required: 'Phone Type is required',
                    })}
                    className='mt-0 w-100'
                    color='secondary'
                    variant='outlined'
                    select
                    label='Type'
                    defaultValue={user && user.Pphone_type}
                  // helperText="Please select your currency"
                  >
                    <MenuItem value='Cell'>Cell </MenuItem>
                    <MenuItem value='Home'>Home </MenuItem>
                    <MenuItem value='Work'>Work </MenuItem>
                    <MenuItem value='Pager'>Pager </MenuItem>
                  </TextField>
                </Grid>
                <Grid className='pt-2' item xs={6} sm={2} md={1} sx={{ minHeight: '90px' }}>
                  <TextField
                    {...register('PhoneProvider', {
                      required: 'Phone Provider is required',
                    })}
                    className='mt-0 w-100'
                    color='secondary'
                    variant='outlined'
                    select
                    label='Cell/Provider'
                    defaultValue={user && user.Pphone_provider}
                  // helperText="Please select your currency"
                  >
                    <MenuItem value='AT&T'>AT&T </MenuItem>
                    <MenuItem value='Sprint'>Sprint </MenuItem>
                    <MenuItem value='TMobile'>TMobile</MenuItem>
                    <MenuItem value='Verizon'>Verizon</MenuItem>
                    <MenuItem value='Google'>Google </MenuItem>
                    <MenuItem value='Consumer Cell'>Consumer Cell</MenuItem>
                  </TextField>
                </Grid>
                <Grid className='pt-2' item xs={6} sm={4} md={2} sx={{ minHeight: '90px' }}>
                  <TextField
                    {...register('email', {
                      required: 'Email is required',
                    })}
                    label='Email'
                    className='mt-0 w-100'
                    color='secondary'
                    variant='outlined'
                    defaultValue={user && user.email}
                  />
                  {errors.email && <Error>{errors.email?.message}</Error>}
                </Grid>
              </Grid>
              <Grid className='my-1' container spacing={2} columns={{ xs: 6, sm: 6, md: 6 }}>
                <Grid className='pt-2 ' item xs={6} sm={6} md={6}>
                  <TextField
                    {...register('message_suffix')}
                    className='mt-0 w-100'
                    color='secondary'
                    variant='outlined'
                    label='Overtime Message Suffix'
                    defaultValue={user?.options && user?.options?.User_Value}
                  />
                  {errors.message_suffix && <Error>{errors.message_suffix?.message}</Error>}
                </Grid>
                <Grid className='pt-2' item xs={6} sm={6} md={6}>
                  <div className='d-flex justify-content-end'>
                    <ButtonTheme
                      disabled={saving || anyChange}
                      type='submit'
                      variant='filled'
                      color='primary'
                      className='px-5'
                    >
                      {saving && 'Loading...'}
                      {!saving && 'Save'}
                    </ButtonTheme>
                  </div>
                </Grid>
              </Grid>
            </form>
          )}
          {!editContactInformation && (
            <Grid container spacing={2} columns={{ xs: 6, sm: 6, md: 6 }}>
              <Grid className='pt-2' item xs={6} sm={4} md={2} sx={{ minHeight: '90px' }}>
                <Card className='p-2 d-flex justify-content-center '>
                  Phone : {user && user.Primary_phone}
                </Card>
              </Grid>
              <Grid className='pt-2' item xs={6} sm={2} md={1} sx={{ minHeight: '90px' }}>
                <Card className='p-2 d-flex justify-content-center '>
                  Type : {user && user.Pphone_type}
                </Card>
              </Grid>
              <Grid className='pt-2' item xs={6} sm={2} md={1} sx={{ minHeight: '90px' }}>
                <Card className='p-2 d-flex justify-content-center '>
                  Provider : {user && user.Pphone_provider}
                </Card>
              </Grid>
              <Grid className='pt-2' item xs={6} sm={4} md={2} sx={{ minHeight: '90px' }}>
                <Card className='p-2 d-flex justify-content-center '>
                  Email : {user && user.email}
                </Card>
              </Grid>
            </Grid>
          )}
        </Card>
        <UserCertificates />

        <PreferencesForm Preferences={Preferences} />

        <UserSwapReport />

        {
          (allowedVars && Object.keys(allowedVars).includes('V3_REMOVE_SELL_ACCRUAL_FEATURE')) ? "" : <SellHoliday userSellHolidayList={userSellHolidayList} />

        }


        {/* <ChangePassword /> */}

        {/* <ProfileSocialMedia emails={Preferences?.social} loadEmails={loadEmails} /> */}
        <br />
        {/* {MyBalance && MyBalance.length > 0 && (
          <Card className='shadow p-3'>
            <MyBalanceTable MyBalance={MyBalance} />
          </Card>
        )} */}


        {sellListData && sellListData.length > 0 && (
          <Card className='shadow p-3 my-3'>
            <SellHolidayTable sellListData={sellListData} />
          </Card>
        )}

        <Card className='shadow p-3'>
          <Grid item xs={12} sm={12} lg={12}>
            <p className="fw-600 fs-18 mt-1">
              Accrual Summary
            </p>
            <MyTable
              rows={summaryRes || []}
              columns={(allowedVars && Object.keys(allowedVars).includes('V3_REMOVE_SELL_ACCRUAL_FEATURE')) ? columnsSummaryCompressed : columnsSummary}
              checkboxSelection={false}
              useTopFilter={false}
              hideFooter={true}
              useSearch={(e) => setSummarySearch(e)}
              sx={{
                height: '100%',
                overflow: 'auto',
              }}
            />
          </Grid>
        </Card>
        {/* {
        MyBalance && MyBalance.length > 0 && (
          <Card className='shadow p-3 my-3'>
            <MyBalanceTable MyBalance={MyBalance} />
          </Card>
        )
        } */}

      </Box>
    </>
  );
}
